import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api.model';
import { State, Lga, AppConfig } from '../models/core.model';

@Injectable({
  providedIn: 'root'
})
export class CoreApiService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  getAppConfig(): Observable<ApiResponse<AppConfig>> {
    return this.http.get<ApiResponse<AppConfig>>(`${this.baseUrl}/core/app-config`);
  }

  getStates(countryId: number | string = 160): Observable<ApiResponse<State[]>> {
    return this.http.get<ApiResponse<State[]>>(`${this.baseUrl}/core/countries/${countryId}/states`);
  }

  getLgas(stateId: number | string): Observable<ApiResponse<Lga[]>> {
    return this.http.get<ApiResponse<Lga[]>>(`${this.baseUrl}/core/states/${stateId}/lgas`);
  }

}
